export default __webpack_public_path__ + "static/instance01-991f11d018371db5033e34c876bb0acc.png";